import { ActionKeys } from "../_actions/constants/homeConstants";

const initialState = {
  isLoading: false,
  isError: false,
  errorMessage: null,
  welcomeMessage: null
};

export default function homeReducer(state, action) {
  state = state || initialState;

  switch (action.type) {
    case ActionKeys.REQUEST_WELCOME_MESSAGE:
      return {
        ...state,
        isLoading: true,
        isError: false
      };
    case ActionKeys.RECEIVE_WELCOME_MESSAGE:
      return {
        ...state,
        welcomeMessage: action.welcomeMessage,
        isLoading: false,
        isError: action.isError,
        errorMessage: action.errorMessage
      };
    default:
      return { ...state };
  }
}
